import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CyloginService, Roles } from '@auth';
import { Profile } from '@core/interfaces';

export const pharmacistGuard: CanActivateFn = (route, state) => {
  const cyLoginService = inject(CyloginService);
  const router = inject(Router);

  const logout_url = sessionStorage.getItem('logout_url');
  const role = sessionStorage.getItem('role');
  const profile = JSON.parse(sessionStorage.getItem('profile')!) as Profile;

  return (
    (logout_url &&
      // role &&
      // role.toString() === Roles.pharmacist &&
      profile &&
      profile.role.toString() === Roles.pharmacist) ||
    new RedirectCommand(router.parseUrl('noaccess'))
  );
};
